<template>
  <div class="login-head-container">
    <img :src="getAssetImageUrl('common/logos/logo-sconchat-full.png')" alt="sconchat-logo" class="sconchat-logo" />
    <h4 class="login-text">
      {{ route.path.includes('/dist') ? t('login_dist') : route.path.includes('/internal') ? '인터널' : '' }}
    </h4>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';

import { getAssetImageUrl } from '@/utils/getAssetImageUrl';

const { t } = useI18n({ useScope: 'global' });
const route = useRoute();
</script>

<style scoped lang="scss">
.login-head-container {
  display: flex;
  margin-bottom: 1rem;
  gap: 0rem;
  justify-content: start;
  align-items: flex-end;
}

.sconchat-logo {
  height: 2.5rem;
}

.login-text {
  margin-bottom: 0.125rem;
}
</style>
